import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { UntilDestroy } from '@ngneat/until-destroy';
import { PDFConfigurations } from '../../items-canvas/board-items/board-pdf-configurations';
import { UserService } from '../../../../services/user.service';
import { PdfManagerService } from '../pdf-services/pdf-manager.service';
import { ResourceItemModel } from '../../../../models/resource';
import { Position } from '../../../../state/space-comments.repository';

@UntilDestroy()
@Component({
  selector: 'app-pdf-viewer-v2[static][state]',
  templateUrl: './pdf-viewer-v2.component.html',
  styleUrls: ['./pdf-viewer-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdfViewerV2Component implements AfterViewInit, OnChanges {
  @Input() static = false;
  @Input() state!: PDFConfigurations;
  @Output() stateChanged = new EventEmitter<PDFConfigurations>();
  @Output() contentSizeAcquired = new BehaviorSubject<
    { width: number; height: number } | undefined
  >(undefined);

  protected showUploadIndicator$ = new BehaviorSubject(false);
  protected loadingPDF$ = new BehaviorSubject<boolean>(true);
  protected pdfPagesPosition$ = new BehaviorSubject<Position[]>([]);

  constructor(private userService: UserService, private pdfManagerService: PdfManagerService) {}

  ngOnChanges(changes) {
    // to load the pdf in case the input changed, and now we have the url
    this.loadPDF();
  }

  ngAfterViewInit(): void {
    this.showUploadIndicator$.next(this.state.ownerId === this.userService.userId);

    // to load the pdf as soon as the component init in case we have the url
    this.loadPDF();
  }

  async loadPDF() {
    if (this.static) {
      return;
    }
    if (!this.loadingPDF$.getValue()) {
      // already loaded
      return;
    }

    const { contentId, url } = this.state;
    if (!url) {
      // PDF is still in the uploading phase
      return;
    }

    const pages = await this.pdfManagerService.getPagesWithViewport(contentId, url);

    if (!pages) {
      // TODO <Hatahet> show error message for the user
      return;
    }

    this.pdfPagesPosition$.next(
      pages.map(({ width, height, shiftFromTop }) => ({
        top: shiftFromTop ?? 0,
        left: 0,
        width,
        height,
      })),
    );
    this.loadingPDF$.next(false);
  }

  protected readonly ResourceItemModel = ResourceItemModel;
}
